import { ChangeTypes } from '@zencity/common-ui';

export const getChangeType = (currentScore: number, previousScore?: number): ChangeTypes | undefined => {
  if (!previousScore) return undefined;
  if (currentScore > previousScore) return ChangeTypes.INCREASE;
  if (currentScore < previousScore) return ChangeTypes.DECREASE;
  return ChangeTypes.NONE;
};
